import { Grid } from '@material-ui/core'
import React from 'react'
import AppButton from '../../../components/atoms/AppButton'
import AppIconWifi from '../../../components/atoms/AppIconWifi'
import AppErrorTemplate from '../../../components/templates/AppErrorTemplate'
import { classes } from '../../../utils/css'
import styles from './AppNotAuthorizedPage.module.css'
import { useTranslation } from 'react-i18next'
export type AppNotFoundProps = {
  onSignInClick?: () => void
}
function AppNotAuthorizedPageView(props: AppNotFoundProps): JSX.Element {
  const { t } = useTranslation()
  return (
    <AppErrorTemplate
      left={<AppIconWifi />}
      right={
        <Grid className={styles.messageContainer}>
          <h1 className={classes(styles.title, styles.notFound)}>
            {t('You do not have access to this screen, please sign in')}
          </h1>
          <Grid className={styles.buttonContainer}>
            <AppButton
              className={classes(styles.button, styles.info)}
              onClick={props.onSignInClick}
            >
              {t('Sign in')}
            </AppButton>
          </Grid>
        </Grid>
      }
    />
  )
}

export default AppNotAuthorizedPageView
